import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";
import { getAuthPolicySelector, isLoadingAppSelector } from "../../modules/App/state/selectors";
import { DEFAULT_ROUTE } from "../../routes/constants";
import { isAllPermissionInclude, isAnyPermissionInclude } from "./utils";
import {Spinner} from "components/Loaders/Spinner/Spinner";
import styles from "./styles.module.scss";

export const PrivateRoute = ({ permission, renderFallback, ...restProps }) => {
    const authPolicyCodes = useSelector(getAuthPolicySelector);
    const isLoading = useSelector(isLoadingAppSelector);

    if(isLoading) {
        return (
            <div className={styles.dialogSpinner}>
                <Spinner/>
            </div>
        );
    }

    let isRenderFallback;

    if (Array.isArray(permission)) {
        isRenderFallback = !permission.every((item) => authPolicyCodes.indexOf(item) !== -1);
    } else {
        isRenderFallback = !authPolicyCodes.some((item) => item === permission);
    }

    if (permission && isRenderFallback) {
        return renderFallback || <Redirect to={DEFAULT_ROUTE} />;
    }

    return <Route {...restProps} />;
};

export const CheckAuthPolicy = ({ withAnyPermission, predicate, renderFallback = null, children = null }) => {
    const authPolicyCodes = useSelector(getAuthPolicySelector);

    let isRenderFallback;

    if(withAnyPermission) {
        isRenderFallback = isAnyPermissionInclude(predicate, authPolicyCodes);
    } else {
        isRenderFallback = isAllPermissionInclude(predicate, authPolicyCodes);
    }


    if (isRenderFallback) {
        return renderFallback;
    }

    return children;
};

CheckAuthPolicy.propTypes = {
    renderFallback: PropTypes.node,
    children: PropTypes.node.isRequired
};
